import { trackAmplitudeEvent } from '@rsos/gainsight';

const GLOBAL_MAP_SEARCH_EVENT_NAMES = {
  VIEW: 'global_map_search_view',
  FOCUS: 'global_map_search_focus',
  CLEAR: 'global_map_search_clear',
  MODE_CHANGE: 'global_map_search_mode_change',
} as const;

export type GlobalMapSearchMode = 'search' | 'command' | 'action';

/** Tracks when the global map search bar first becomes available in the nav. */
export const trackGlobalMapSearchView = () => {
  trackAmplitudeEvent(GLOBAL_MAP_SEARCH_EVENT_NAMES.VIEW, {
    route: 'Map',
  });
};

/** Tracks when the user focuses the global map search input. */
export const trackGlobalMapSearchFocus = () => {
  trackAmplitudeEvent(GLOBAL_MAP_SEARCH_EVENT_NAMES.FOCUS, {
    route: 'Map',
  });
};

/** Tracks when the user clears the global map search input. */
export const trackGlobalMapSearchClear = () => {
  trackAmplitudeEvent(GLOBAL_MAP_SEARCH_EVENT_NAMES.CLEAR, {
    route: 'Map',
  });
};

/**
 * Tracks when the input prefix switches the active experience
 * (regular search ↔ slash command ↔ `//` action).
 */
export const trackGlobalMapSearchModeChange = ({
  mode,
}: {
  mode: GlobalMapSearchMode;
}) => {
  trackAmplitudeEvent(GLOBAL_MAP_SEARCH_EVENT_NAMES.MODE_CHANGE, {
    route: 'Map',
    search_mode: mode,
  });
};
